import { memo as Memo, useRef, useState, useCallback } from 'react';
import gsap from 'gsap';

//* HOC
import { withUIContext } from 'context';

//* Components
import Image from 'components/common/Image';
import Icon from 'components/common/Icon';
import Text from 'components/common/Text';
import { Swiper, SwiperSlide } from 'swiper/react';

//* Style
import SliderStyle from './style';
import 'swiper/css';

const Slider = Memo(({ className, slider_images, winWidth, isLightTheme }) => {
	//! States
	const [activeIndex, setActiveIndex] = useState(0);
	const [crsState, setCrsState] = useState('crs-hide');
	const [crsHide, setCrsHide] = useState(true);

	//! Refs
	const swiperRef = useRef(null);
	const crsNames = useRef({
		left: 'bb-arrow reverse',
		right: 'bb-arrow',
	});
	const crsRef = useRef();

	//! Change cursor position and style
	const changeCrsPosition = useCallback(
		(e, index) => {
			const windowPart = window.innerWidth / 2;
			const pos = (e.clientX - windowPart) / windowPart;
			const crsName = pos >= 0 ? crsNames.current.right : crsNames.current.left;
			// (pos >= 0  /* && index !== slider_images.length - 1 */) || (pos < 0 /* && index === 0 */) ? crsNames.current.right : crsNames.current.left

			crsName !== crsState && setCrsState(crsName);
			gsap.set(crsRef.current, { left: e.clientX, top: e.clientY });
		},
		[crsRef.current, crsNames.current, crsState, activeIndex]
	);

	//! Handle mouse move
	const handleMouseMove = useCallback(
		(e) => {
			crsHide && setCrsHide(false);
			changeCrsPosition(e, activeIndex);
		},
		[changeCrsPosition, activeIndex, crsHide]
	);

	//! Handle Click
	const handleClick = useCallback(
		(e) => {
			changeCrsPosition(e, crsState === crsNames.current.left ? activeIndex - 1 : activeIndex + 1);
			eval(`swiperRef.current.swiper.${crsState === crsNames.current.left ? 'slidePrev()' : 'slideNext()'}`);
		},
		[crsState, activeIndex, swiperRef.current, crsNames.current, changeCrsPosition]
	);

	return (
		<SliderStyle className={`${className || ''}`}>
			<div
				className='slider-container'
				onMouseMove={handleMouseMove}
				onMouseLeave={() => setCrsHide(true)}
				onClick={handleClick}>
				<Swiper
					ref={swiperRef}
					className={`sliderWrap crHide`}
					slidesPerView={'auto'}
					spaceBetween={12}
					onSlideChange={(swiper) => {
						setActiveIndex(swiper.realIndex);
					}}
					loop={true}
					breakpoints={{
						2560: { spaceBetween: 28 },
						1920: { spaceBetween: 20 },
						1510: { spaceBetween: 16 },
						1440: { spaceBetween: 16 },
						1280: { spaceBetween: 12 },
						1024: { spaceBetween: 12 },
						768: { spaceBetween: 12 },
					}}>
					{slider_images.map((item, ind) => {
						return (
							<SwiperSlide key={ind}>
								<Image
									priority
									src={item.url}
									alt={item.alt}
								/>
							</SwiperSlide>
						);
					})}
				</Swiper>
			</div>

			{winWidth >= 1024 && (
				<Icon
					ref={crsRef}
					className={`crs-cont ${!isLightTheme ? 'dark' : ''} ${crsState} ${crsHide ? 'crs-hide' : ''} `}
				/>
			)}

			<div className={`pagAndNavWrap`}>
				<Icon
					className={`bb-light_arrow left linkWrap `}
					onClick={() => swiperRef.current.swiper.slidePrev()}
				/>
				<div className={`paginationWrap`}>
					<Text
						className={`gilroyMedium p blackRussian`}
						text={activeIndex + 1 || 1}
					/>
					<Text
						className={`gilroyMedium p blackRussian`}
						text={'/'}
					/>
					<Text
						className={`gilroyMedium p blackRussian`}
						text={slider_images.length}
					/>
				</div>
				<Icon
					className={`bb-light_arrow right linkWrap`}
					onClick={() => swiperRef.current.swiper.slideNext()}
				/>
			</div>
		</SliderStyle>
	);
});

export default withUIContext(Slider, ['winWidth', 'isLightTheme']);
